export const events = ['render', 'view', 'preselect', 'select', 'clear']
